import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchQueryFiltersModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchQueryFiltersModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchQueryFiltersModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchQueryFiltersModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchQueryFiltersModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
